"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = secp256k1Recover;

var _elliptic = _interopRequireDefault(require("elliptic"));

// Copyright 2017-2020 @polkadot/util-crypto authors & contributors
// This software may be modified and distributed under the terms
// of the Apache-2.0 license. See the LICENSE file for details.
const EC = _elliptic.default.ec;
const ec = new EC('secp256k1');
/**
 * @name secp256k1Recover
 * @description Recovers a publicKey from the supplied signature
 */

function secp256k1Recover(message, signature, recovery) {
  return new Uint8Array(ec.recoverPubKey(message, {
    r: signature.slice(0, 32),
    s: signature.slice(32, 64)
  }, recovery).encode(null, true));
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@polkadot/util-crypto/secp256k1/recover.js
// module id = 509
// module chunks = 0